<script lang="ts">
  /**
   * Reusable Loading Spinner Component
   *
   * Uses shared CSS classes from styles/components.css
   *
   * Usage:
   * <LoadingSpinner />
   * <LoadingSpinner size="small" />
   * <LoadingSpinner size="large" light />
   */

  type SpinnerSize = 'small' | 'medium' | 'large';

  interface Props {
    size?: SpinnerSize;
    /** Use light variant for dark backgrounds (white spinner) */
    light?: boolean;
  }

  let { size = 'medium', light = false }: Props = $props();

  let sizeClass = $derived(
    size === 'small' ? 'spinner-small' :
    size === 'large' ? 'spinner-large' : ''
  );
</script>

<div
  class="spinner {sizeClass}"
  class:spinner-light={light}
  role="status"
  aria-label="Loading"
></div>

<style>
  /* Light variant for dark backgrounds */
  .spinner-light {
    border-color: rgba(255, 255, 255, 0.3);
    border-top-color: white;
  }
</style>
